import { Grid, FormControl, InputLabel, Select, MenuItem, Box, SelectChangeEvent } from "@mui/material";
import { StatusPlanningIcon, StatusActiveIcon, StatusClosedIcon, StatusArchivedIcon } from '../../../../../assets/icons/icons';
import { Operation } from "src/networkRequest/operationsService";

const OperationStatus = ({ status, onChange }: {
  status: string;
  onChange: (status: Operation['status']) => Promise<void>;
}) => {
  const handleStatusChange = async (event: SelectChangeEvent): Promise<void> => {
    const newStatus = event.target.value as Operation['status'];
    if (newStatus !== status) {
      try {
        await onChange(newStatus);
      } catch (error) {
        console.error('Failed to update operation status:', error);
      }
    }
  };

  return (
    <Grid size="auto">
      <FormControl variant="outlined" size="small" sx={{ 
        width: '286px',
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: 'inputOutlinedBorder'
        }
      }}>
        <InputLabel id="operation-status-label">Status</InputLabel>
        <Select
          labelId="operation-status-label"
          id="operation-status-select"
          value={status}
          label="Status"
          onChange={handleStatusChange}
        >
          <MenuItem value="planning">
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <StatusPlanningIcon style={{ width: 20, height: 20 }} />
              Planning
            </Box>
          </MenuItem>
          <MenuItem value="active">
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <StatusActiveIcon style={{ width: 20, height: 20 }} />
              Active
            </Box>
          </MenuItem>
          <MenuItem value="closed">
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <StatusClosedIcon style={{ width: 20, height: 20 }} />
              Closed
            </Box>
          </MenuItem>
          <MenuItem value="archived">
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <StatusArchivedIcon style={{ width: 20, height: 20 }} />
              Archived
            </Box>
          </MenuItem>
        </Select>
      </FormControl>
    </Grid>
  );
}

export default OperationStatus;